module.exports = __webpack_public_path__ + "static/media/scene5_didi5.100b0829.wav";